var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"debug"},[_c('section',[_c('camera',{attrs:{"nodeData":_vm.nodeData,"lf":_vm.lf,"socketResponse":_vm.socketResponse},on:{"onClose":_vm.handleClose,"capturePic":_vm.capturePic}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }